import type {
  IssueHolding,
  IssueStartResult,
  IssueTakeOverResult,
  LandingRecord,
  LandingStartResult,
  LandingTakeOverResult,
} from '../types/domain.types';

const NOT_OPEN = { kind: 'NOT_OPEN' } as const;
const NOT_STARTED = { kind: 'NOT_STARTED' } as const;

const holdingOf = ({ startedBy, status, nextAction }: IssueHolding): IssueHolding => ({ startedBy, status, nextAction });

export const holdingAfter = (result: IssueStartResult): IssueHolding | null => (result.outcome === 'NOT_FOUND' ? null : holdingOf(result));

export const landingStartOutcome = (record: LandingRecord, result: IssueStartResult): LandingStartResult => {
  switch (result.outcome) {
    case 'STARTED':
      return { kind: 'STARTED', ...holdingOf(result), hooterSilenced: result.hooterSilenced, appPath: record.appPath };
    case 'ALREADY_STARTED':
      return { kind: 'ALREADY_STARTED', ...holdingOf(result) };
    case 'NOT_FOUND':
      return NOT_OPEN;
  }
};

export const landingTakeOverOutcome = (record: LandingRecord, result: IssueTakeOverResult): LandingTakeOverResult => {
  switch (result.outcome) {
    case 'TAKEN_OVER':
      return { kind: 'TAKEN_OVER', ...holdingOf(result), appPath: record.appPath };
    case 'ALREADY_YOURS':
      return { kind: 'ALREADY_YOURS', ...holdingOf(result), appPath: record.appPath };
    case 'NOT_STARTED':
      return NOT_STARTED;
    case 'NOT_FOUND':
      return NOT_OPEN;
  }
};
